import { post } from '../Services/http';
import { catchError } from './Error.action';
import {
	NEWSLETTER_RECEIVE,
	NEWSLETTER_SUBMIT_ERROR,
	NEWSLETTER_SUBMIT_DONE,
	CLEAR_ERROR,
} from '../constants';

export const subscribeToNewsletter = (emailAddress) => async (dispatch) => {
	return post('/api/newsletter/subscribetonewsletter', { email: emailAddress })
		.then((response) => response.json())
		.then((result) => {
			dispatch(submitDone(result));
		})
		.catch((ex) => catchError(ex));
};

export const receive = (subscriptionResponse) => ({
	type: NEWSLETTER_RECEIVE,
	payload: {
		subscriptionResponse,
	},
});

export const clearError = () => ({
	type: CLEAR_ERROR,
	payload: {
		errors: [],
	},
});

export const submitError = (error) => ({
	type: NEWSLETTER_SUBMIT_ERROR,
	payload: {
		error,
	},
});

export const submitDone = (result) => ({
	type: NEWSLETTER_SUBMIT_DONE,
	payload: {
		result,
	},
});